<template>
   <div class="container">
    <div class="container mt-5">
      <p class="title has-text-weight-semibold">Stats</p>
       <br/>
    </div>
    <div class="container">
      <p class="subtitle">Totals</p>
      <span>&#128169 </span>{{ countSolid }} <br/>
      <span>&#128701 </span>{{ countLiquid }}<br/>
      <span>&#127868 </span>{{ countFeed }}<br/>
    </div>
    <br/>
     <div class="container">
      <p class="subtitle">Today</p>      
      <span>&#128169 </span>{{ isToday('Solid') }} <br/>
      <span>&#128701 </span>{{ isToday('Liquid') }}<br/>
      <span>&#127868 </span>{{ isToday('Feed') }}<br/>
    </div>
    <br/>
     <div class="container">
      <p class="subtitle">Yesterday</p>      
      <span>&#128169 </span>{{ isYesterday('Solid') }} <br/>
      <span>&#128701 </span>{{ isYesterday('Liquid') }}<br/>
      <span>&#127868 </span>{{ isYesterday('Feed') }}<br/>
    </div>
    
  </div>
</template>

<script>
import db from '../fireBaseInit'
import getLogs from '../helpers/fireBaseGet'

export default {
  data(){
    return {
      eventList: [],
      eventType: [
        { name: 'Feed', 'icon': '&#127868' },
        { name: 'Solid', 'icon': '&#128169' },
        { name: 'Liquid', 'icon': '&#128701' }
      ],
    }
  },
  methods: {
    isToday(type) {
      let today = new Date()
      return this.eventList.filter(event => {
        let temp = new Date(event.timestamp)
          return temp.getDate() == today.getDate() && temp.getMonth() == today.getMonth() && temp.getFullYear() == today.getFullYear() && event.type == type
        
      }).length
    },
    isYesterday(type){
      let yesterday = new Date()
      yesterday.setDate(yesterday.getDate() -1)
      return this.eventList.filter(event => {
        let temp = new Date(event.timestamp)
          return temp.getDate() == yesterday.getDate() && temp.getMonth() == yesterday.getMonth() && temp.getFullYear() == yesterday.getFullYear() && event.type == type
        
      }).length
    }
  },
  computed: {
    countSolid(){
      return this.eventList.filter(doc => doc.type == 'Solid').length
    },
     countLiquid(){
      return this.eventList.filter(doc => doc.type == 'Liquid').length
    },
     countFeed(){
      return this.eventList.filter(doc => doc.type == 'Feed').length
    }
  },
   async created() {
    let loadData = await getLogs(db)
    loadData.forEach(x => {
      this.eventList.push({
        "id": x.id,
        "type": x.data().type,
        "timestamp": x.data().timestamp.toDate()
      })
    })
  }

}
</script>

<style>

</style>